import './BetCounts.less';

import clsx from 'clsx';
import React from 'react';

export function BetCounts({ className, betStatusCounts }) {
    const { Cancelled, Lost, Registered, Returned, Won } = betStatusCounts;
    return (
        <ul className={clsx('bet-counts', className)}>
            {Won ? <li className="winning">{Won}</li> : null}
            {Registered ? <li className="registered">{Registered}</li> : null}
            {Lost ? <li className="lost">{Lost}</li> : null}
            {Cancelled ? <li className="canceled">{Cancelled}</li> : null}
            {Returned ? <li className="returned">{Returned}</li> : null}
        </ul>
    );
}
export function BetCountsLoader({ className }) {
    return (
        <ul className={clsx('bet-counts loader', className)}>
            <li className="wave-animation" />
        </ul>
    );
}
